class BaseMooringCage {
  MoorlogNo!: string;
  AnalysisNo!: string;
  PenCircumference!: number;
  FloaterId!: number;
  Row!: number;
  Column!: number;
}

export class UpdateMooringCageDto extends BaseMooringCage {
  Id!: number;
}

export class AddMooringCageDto {
  MoorlogNo!: string;
  AnalysisNo!: string;
  FloaterId!: number;
  PenCircumference!: number;
}

export class MooringCage extends BaseMooringCage {
  Id!: number;

  HasUnresolvedComments!: boolean;
  HasComments!: boolean;
  FloaterName!: string;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Components!: any[];
}
